// extracted by mini-css-extract-plugin
module.exports = {"tagList":"tag-list_tagList__2aW6-","tag":"tag-list_tag__1Xkdy","selected":"tag-list_selected__1LCf5"};